import { useReactFlow } from '@xyflow/react'
import { useCallback, useEffect, useRef } from 'react'

import { QueueNodeData } from '../../../converters/shared/reactFlowTypes'

/**
 * Hook for queue node functionality.
 * Handles queue ID and max wait time updates.
 */
export const useQueueNode = (id: string, data: QueueNodeData) => {
  const { updateNodeData } = useReactFlow()
  const dataRef = useRef(data)

  // Keep dataRef in sync with data
  useEffect(() => {
    dataRef.current = data
  }, [data])

  const currentQueueId = data.queueId ? String(data.queueId) : ''

  const handleQueueChange = useCallback(
    (queueId: string | undefined) => {
      updateNodeData(id, {
        ...dataRef.current,
        queueId,
      })
    },
    [id, updateNodeData],
  )

  const handleMaxWaitTimeChange = useCallback(
    (maxWaitTime: number | undefined) => {
      updateNodeData(id, {
        ...dataRef.current,
        maxWaitTime,
      })
    },
    [id, updateNodeData],
  )

  return {
    currentQueueId,
    handleQueueChange,
    handleMaxWaitTimeChange,
    hasData: !!currentQueueId,
  }
}
